// extracted by mini-css-extract-plugin
export default {"project":"project_project__AYgyo","cards":"project_cards__Nj+3+","projectTitle":"project_projectTitle__Gd2vU"};